import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { windowActions } from '../../store/windowStore';
import classnames from 'classnames';

import './windows/window.scss';
import DraggableWindow from './windows/draggableWindow';

class WindowManager extends React.Component {
    render() {
        var keys = Object.keys(this.props.win).filter(x => this.props.win[x] !== undefined && this.props.win[x] !== null && this.props.win[x].isInitialized && this.props.win[x].isOpen);
        if(keys.length === 0) {
            return null;
        }
        return keys.map(w => this.renderWindow(this.props.win[w]));
    }

    renderWindow = (window) => {
        if(window.dragAllowed) { return this.renderDragable(window); }

        this.renderStatic(window);
    }

    renderDragable = (window) => {
        const C = window.component;
        return (
            <DraggableWindow id={`window-id-${window.id}`} dragable={window.dragEnabled} position={window.position} offset={window.offset} className={classnames('window', {'dragable':window.dragEnabled})} key={window.id}>
                <C id={window.id} dragAllowed={window.dragAllowed} dragEnabled={window.dragEnabled} {...window.componentProps} />
            </DraggableWindow>
        );
    }

    renderStatic = (window) => {
        const C = window.component;
        return (
            <div id={`window-id-${window.id}`} className='window' key={window.id} style={{transform: `translate(${window.position.x}px, ${window.position.y}px)`}}>
                <C id={window.id} dragAllowed={window.dragAllowed} dragEnabled={window.dragEnabled} {...window.componentProps} />
            </div>
        );
    }
}

export default connect(
    state => ({ win: state.windows }),
    dispatch => bindActionCreators(windowActions, dispatch)
)(WindowManager);